import React from 'react';
import tw from 'twin.macro'; //eslint-disable-line
import AnimationRevealPage from 'helpers/AnimationRevealPage.js';
import Footer from 'components/footers/MiniCenteredFooter.js';
import Hero from '../components/hero/TwoColumnWithFeaturesAndTestimonial.js';
import FeatureWithSteps from '../components/features/TwoColWithSteps.js';
import enrollment from 'images/enrollment.jpg';
import NavBar from 'components/navbars/basic.js';

const Subheading = tw.span`uppercase tracking-widest font-bold text-primary-500`;
const HighlightedText = tw.span`text-primary-500`;

export default () => (
  <AnimationRevealPage>
    <NavBar />
    <Hero />

    <FeatureWithSteps
      subheading={<Subheading>Enrollment</Subheading>}
      heading={
        <>
          Easy to <HighlightedText>Come Onboard.</HighlightedText>
        </>
      }
      textOnLeft={false}
      imageSrc={enrollment}
      imageDecoratorBlob={true}
      decoratorBlobCss={tw`xl:w-40 xl:h-40 opacity-15 -translate-x-1/2 left-1/2`}
    />
    <Footer />
  </AnimationRevealPage>
);
